<script setup lang="ts">
import { defineProps } from 'vue'
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'
defineProps(['params'])
</script>

<template>
  <div class="flex items-center gap-2 w-full">
    <div class="w-fit">
      <ButtonDaisy text="Editer" @click="params.onClick(params.data)" />
    </div>
  </div>
</template>
